<h1>My Running Plan</h1>
<section id="beginner-running-workout-plan">
<h2>My Beginner Running Plan</h2>
<p class="beginner-running-workouts" id="beginner-running-workouts"></p>
<div class="row">
<ng-container *ngFor="let workout of beginnerRunningPlan">
    <div class="col-lg-3">
    <h3>{{workout.day}}</h3>
    <h3>{{workout.workoutType}}</h3>
    <ul>
        <li>{{workout.workout1}}</li>
        <li>{{workout.workout2}}</li>
        <li>{{workout.workout3}}</li>
    </ul>
    </div>
</ng-container>
</div>
</section>

<section id="intermediate-running-workout-plan">
    <h2>My Intermediate Running Plan</h2>
    <p class="intermediate-running-workouts" id="intermediate-running-workouts"></p>
    <div class="row">
    <ng-container *ngFor="let workout of intermediateRunningPlan">
        <div class="col-lg-4">
        <h3>{{workout.day}}</h3>
        <h3>{{workout.workoutType}}</h3>
        <ul>
            <li>{{workout.workout1}}</li>
            <li>{{workout.workout2}}</li>
            <li>{{workout.workout3}}</li>
        </ul>
        </div>
    </ng-container>
    </div>
</section>
    
<section id="advanced-running-workout-plan">
    <h2>My Advanced Running Plan</h2>
    <p class="advanced-running-workouts" id="advanced-running-workouts"></p>
    <div class="row">
    <ng-container *ngFor="let workout of advancedRunningPlan">
        <div class="col-lg-4">
        <h3>{{workout.day}}</h3>
        <h3>{{workout.workoutType}}</h3>
        <ul>
            <li>{{workout.workout1}}</li>
            <li>{{workout.workout2}}</li>
            <li>{{workout.workout3}}</li>
        </ul>
        </div>
    </ng-container>
    </div>
</section>
